import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptParis75 = () => {
  return (
    <DepartmentTemplate
      department="Paris"
      departmentNumber="75"
      cities="Tous arrondissements, du 1er au 20ème"
      region="Île-de-France"
    />
  );
};

export default DeptParis75;
